module.exports = __webpack_public_path__ + "static/media/facebook.58134fcf.svg";